import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterPreloader } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-investigate',
  templateUrl: './investigate.component.html',
  styleUrls: ['./investigate.component.scss']
})
export class InvestigateComponent implements OnInit {
  Action: any;

  constructor(
    private Route: ActivatedRoute
  ) {
    this.Route.queryParams.subscribe((Params: any) => {
      this.Action = Params["a"];
    });
   }

  ngOnInit() {
    $("#title").html(this.Action == "1" ? "ขอตรวจสอบ" : "อุทธรณ์");
  }

}



// WEBPACK FOOTER //
// ./src/app/investigate/investigate.component.ts